import { render, staticRenderFns } from "./DeleteChatConfirmationModal.vue?vue&type=template&id=7f67871e"
import script from "./DeleteChatConfirmationModal.vue?vue&type=script&lang=js"
export * from "./DeleteChatConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports